import React from 'react';
import { Link } from 'react-router-dom';
import { Home } from '@/components/atoms/AppIcon';
import { MASSAGER_JA } from '@/shared/i18n/massager';

interface VisitAddressRowProps {
  /** Concatenated patient address string from the visit row. */
  address: string;
  /** External Google Maps URL. Renders the 地図 link when truthy. */
  mapUrl: string | null;
}

/**
 * Patient address line with the home icon and the 地図 link. Mirrors the row
 * in VisitCard but sits inside the edit page below the sudden-visit form.
 */
const VisitAddressRow: React.FC<VisitAddressRowProps> = ({ address, mapUrl }) => {
  if (!address) return null;
  return (
    <div className="flex flex-wrap items-center gap-2 text-sm text-gray-900">
      <span className="flex h-7 w-7 shrink-0 items-center justify-center text-xl leading-none text-emerald-600">
        <Home />
      </span>
      <span className="break-all">{address}</span>
      {mapUrl && (
        <Link
          to={mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center rounded bg-emerald-500 px-2.5 py-1 text-xs font-medium text-white hover:bg-emerald-600"
        >
          {MASSAGER_JA.action.mapLink}
        </Link>
      )}
    </div>
  );
};

export default VisitAddressRow;
